export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6285.2f666f82.jpg";